module.exports = __webpack_public_path__ + "img/94e0360bc22ef8e71908f6a244671465.png";